import {CookieUtils} from '../../../../common/utils';
import {StorageHolder} from "../../../../common/core/storage/StorageHolder";

export class CookiesManager {

    private static TOKEN_COOKIE = 'COToken';
    private static TOKEN_EXPIRES = 'COToken-expires';
    private static DESTINATION_URL_COOKIE = 'CODURL';
    private static NEXYIU_REF_CODE = 'refCode';
    private static PAYMENT_EXPRESS_ALLOWED = 'payment_express_allowed';
    private static FEE_VALUE = 'fee_value';
    private static CONSENT_ID = 'consentId';
    private static CALL_BACK_URL = 'callbackURL';
    private static CUSTOMER_MANUAL_CODE = 'manualCode';

    static isTokenExist(): boolean {
        return CookieUtils.check(CookiesManager.TOKEN_COOKIE);
    }

    static isTokenExpiresExist(): boolean {
        return CookieUtils.check(CookiesManager.TOKEN_EXPIRES);
    }

    static getToken(): string {
        return CookieUtils.get(CookiesManager.TOKEN_COOKIE);
    }

    static getTokenExpireMinutes(): number {
        return JSON.parse(StorageHolder.localStorage.getItem(CookiesManager.TOKEN_EXPIRES));
    }

    static setToken(token: string, expires?: number) {
        if (expires) StorageHolder.localStorage.setItem(CookiesManager.TOKEN_EXPIRES, JSON.stringify(expires));
        let seconds: number = CookiesManager.getTokenExpireMinutes() * 60;
        CookieUtils.set(CookiesManager.TOKEN_COOKIE, token, CookiesManager.getTokenExpireDate(seconds));
        CookieUtils.set(CookiesManager.TOKEN_EXPIRES, JSON.stringify(expires), CookiesManager.getTokenExpireDate(20));
    }

    static updateTokenExpires() {
        if (CookiesManager.isTokenExist()) {
            let expires = JSON.stringify(CookiesManager.getTokenExpireMinutes());
            CookieUtils.set(CookiesManager.TOKEN_EXPIRES, expires, CookiesManager.getTokenExpireDate(20));
        }
    }

    static clearToken() {
        CookieUtils.remove(CookiesManager.TOKEN_COOKIE);
        CookieUtils.remove(CookiesManager.TOKEN_EXPIRES);
    }

    static isDestinationURLExists() {
        return CookieUtils.check(CookiesManager.DESTINATION_URL_COOKIE);
    }

    static getDestinationURL(): string {
        return CookieUtils.get(CookiesManager.DESTINATION_URL_COOKIE);
    }

    static setDestinationURL(url: string) {
        CookieUtils.set(CookiesManager.DESTINATION_URL_COOKIE, url);
    }

    static getRefCode(): string {
        return CookieUtils.get(CookiesManager.NEXYIU_REF_CODE);
    }

    static setRefCode(refCode: string) {
        CookieUtils.set(CookiesManager.NEXYIU_REF_CODE, refCode);
    }

    static getManualCode(): string {
        return CookieUtils.get(CookiesManager.CUSTOMER_MANUAL_CODE);
    }

    static setManualCode(refCode: string) {
        CookieUtils.set(CookiesManager.CUSTOMER_MANUAL_CODE, refCode);
    }

    static clearManualCode() {
        CookieUtils.remove(CookiesManager.CUSTOMER_MANUAL_CODE);
    }

    static getConsentId(): string {
        return CookieUtils.get(CookiesManager.CONSENT_ID);
    }

    static setConsentId(consentId: string) {
        CookieUtils.set(CookiesManager.CONSENT_ID, consentId);
    }

    static getCallbackURL(): string {
        return CookieUtils.get(CookiesManager.CALL_BACK_URL);
    }

    static setCallbackURL(callbackURL: string) {
        CookieUtils.set(CookiesManager.CALL_BACK_URL, callbackURL);
    }

    static clearOpenBank() {
        CookieUtils.remove(CookiesManager.CONSENT_ID);
        CookieUtils.remove(CookiesManager.CALL_BACK_URL);
    }

    static clearDestinationURL() {
        CookieUtils.remove(CookiesManager.DESTINATION_URL_COOKIE);
    }

    static getExpressAllowed(): string {
        return CookieUtils.get(CookiesManager.PAYMENT_EXPRESS_ALLOWED);
    }

    static setExpressAllowed(allowed: string) {
        CookieUtils.set(CookiesManager.PAYMENT_EXPRESS_ALLOWED, allowed);
    }

    static getFeeValue(): string {
        return CookieUtils.get(CookiesManager.FEE_VALUE);
    }

    static setFeeValue(allowed: string) {
        CookieUtils.set(CookiesManager.FEE_VALUE, allowed);
    }

    private static getTokenExpireDate(seconds: number): Date {
        return new Date(new Date().getTime() + seconds * 1000);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/core/cookies/cookies.manager.ts